import { cn } from '@/utils/cn'

export interface ConfigTabItem {
  id: string
  label: string
  icon: React.ReactNode
}

interface ConfigTabsNavProps {
  tabs: ConfigTabItem[]
  activeTab: string
  onTabChange: (id: string) => void
}

/**
 * Navegação secundária de Configurações — chips com flex-wrap.
 * Evita segundo sidebar (já existe o menu global) e scroll horizontal.
 */
export function ConfigTabsNav({ tabs, activeTab, onTabChange }: ConfigTabsNavProps) {
  return (
    <nav
      role='tablist'
      aria-label='Seções de configurações'
      className='rounded-2xl border border-white/[0.06] bg-black/20 p-2'
    >
      <ul className='flex flex-wrap gap-1.5'>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id
          return (
            <li key={tab.id}>
              <button
                type='button'
                role='tab'
                aria-selected={isActive}
                onClick={() => onTabChange(tab.id)}
                className={cn(
                  'flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold uppercase tracking-wide transition-all min-h-[40px]',
                  isActive
                    ? 'bg-accent text-white shadow-sm shadow-accent/25'
                    : 'text-text-muted hover:bg-white/[0.06] hover:text-text-primary',
                )}
              >
                <span className='shrink-0 opacity-90' aria-hidden>
                  {tab.icon}
                </span>
                <span className='whitespace-nowrap'>{tab.label}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
